import { frontendURL } from 'dashboard/helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/rfm'),
    component: () => import('rfm/pages/RfmPage.vue'),
    name: 'rfm_overview',
    meta: { permissions: ['administrator', 'agent'] },
    redirect: to => ({
      name: 'rfm_tab',
      params: { ...to.params, tab: 'overview' },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/rfm/:tab'),
    component: () => import('rfm/pages/RfmPage.vue'),
    name: 'rfm_tab',
    meta: { permissions: ['administrator', 'agent'] },
  },
];
